import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { formatPrice, roundToFranc } from './utils/price';
import 'bootstrap/dist/css/bootstrap.min.css';  // Bootstrap CSS
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

// Font Awesome Imports
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUsers,
  faBox,
  faEdit,
  faTrash,
  faUserPlus,
  faList,
  faPlus,
  faTags,
  faCashRegister,
  faArrowLeft,
  faFileInvoiceDollar,
  faUserCog,
  faCheckCircle,
  faUndo,
  faTrashAlt,
  faBoxOpen,
  faChartLine,
  faDownload
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';


// Icons zur FontAwesome-Bibliothek hinzufügen
library.add(
  faUsers,
  faBox,
  faTrash,
  faEdit,
  faUserPlus,
  faList,
  faPlus,
  faTags,
  faCashRegister,
  faArrowLeft,
  faFileInvoiceDollar,
  faUserCog,
  // Status-Icons
  faCheckCircle,
  faUndo,
  faTrashAlt,
  faBoxOpen,
  faChartLine,
  faDownload
);

const app = createApp(App);
app.use(router);
app.component('font-awesome-icon', FontAwesomeIcon);
app.config.globalProperties.$formatPrice = formatPrice;
app.config.globalProperties.$roundToFranc = roundToFranc;
app.mount('#app');
